import { makeStyles } from "@material-ui/styles";

export const useStyles = makeStyles((theme) => ({
  container: {
    justifyContent: "flex-start",
    overflowX: "auto",
    padding: theme.spacing(0.25),
    [theme.breakpoints.up(theme.breakpoints.values.xs)]: {
      display: "none",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs)]: {
      display: "flex",
    },
  },
  itemLink: {
    display: "inline-flex",
    alignItems: "center",
    backgroundColor: ({ theme }) => (theme === "light" ? "#f2f2f2" : "#2a2a2a"),
    border: ({ theme }) =>
      theme === "light" ? "1px solid #ccc" : "1px solid #333",
    color: ({ theme }) => (theme === "light" ? "#2a2a2a" : "#f2f2f2"),
    borderRadius: "16px",
    padding: theme.spacing(0.5, 1.5),
    marginRight: theme.spacing(1),
    textDecoration: "none",
    whiteSpace: "nowrap",
    fontSize: "0.9rem",
    "&:hover": {
      color: ({ theme }) => (theme === "light" ? "#000" : "#fff"),
    },
  },
  icon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: theme.spacing(0.5),
    "& i, & svg": {
      fill: ({ theme }) => (theme === "light" ? "#000" : "#fff"),
      width: "0.9rem",
      height: "0.9rem",
      fontSize: "0.9rem",
    },
  },
  containerMobile: {
    [theme.breakpoints.up(theme.breakpoints.values.xs)]: {
      display: "flex",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs)]: {
      display: "none",
    },
  },
  dropdownButton: {
    alignItems: "center",
    backgroundColor: ({ theme }) => (theme === "light" ? "#f2f2f2" : "#2a2a2a"),
    border: ({ theme }) =>
      theme === "light" ? "1px solid #ccc" : "1px solid #333",
    color: ({ theme }) => (theme === "light" ? "#2a2a2a" : "#f2f2f2"),
    borderRadius: "16px",
    padding: "4px 12px",
    textDecoration: "none",
    height: "fit-content",
    whiteSpace: "nowrap",
    fontSize: "0.9rem",
    fontWeight: "normal",
    display: "flex",
    "& .MuiButton-label": {
      gap: "2px",
    },
  },
}));
